export default __webpack_public_path__ + "static/ScalingResponsive-d24f39566c2e428f5f603815c656fabe.png";